<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/H6sL8z/tc-custom/9783988268440.jpg?1704453360307" alt="This image is the cover for the book Second Stage Lensmen, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Second Stage Lensmen, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Second Stage Lensmen continues the epic saga of the Lensman series. In this installment, the story follows the protagonist, Kimball Kinnison, who has achieved the status of a Second Stage Lensman, possessing immense power and responsibility in the Galactic Patrol. Kinnison, as a Second Stage Lensman, is granted extraordinary abilities, including advanced telepathic and telekinetic powers. These capabilities are essential in the ongoing battle against the Boskone, a nefarious and powerful criminal organization that seeks to dominate the universe. The Lensmen, including Kinnison, work tirelessly to combat the Boskone and its minions across the galaxy. Kinnison's mission is to uncover the true leaders of Boskone and dismantle their evil influence, ensuring peace and justice prevail in the cosmos. As the story unfolds, Kinnison faces various challenges and adversaries, using his newfound powers and wit to navigate the complex and dangerous world of interstellar conflict. Along the way, he forms alliances, unravels mysteries, and engages in epic battles to uphold the values of the Galactic Patrol. "Second Stage Lensmen" is a thrilling and action-packed addition to the Lensman series, showcasing the struggle for order and freedom in a vast, technologically advanced universe. It captivates readers with its imaginative storytelling, futuristic concepts, and the age-old struggle between good and evil on a cosmic scale.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        E. E. Smith
      </h2>
      
      <p class="authorDescription body article">Edward Elmer Smith, also known as E. E. "Doc" Smith, (May 2, 1890 – August 31, 1965) was an American author and a pioneer in the science fiction genre, particularly known for his space opera series. He played a significant role in shaping early science fiction, especially in the realm of space adventures and interstellar conflicts.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?65d5b60e